import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AmbassadorLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/ambassadors/login`, { email, password }, { withCredentials: true });
      navigate("/ambassador");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed — try again.");
      setLoading(false);
    }
  };

  const inputCls =
    "w-full h-12 bg-transparent border border-white/20 focus:border-volt px-4 font-plex text-sm text-white outline-none transition-colors duration-300 placeholder:text-white/30";

  return (
    <div data-testid="ambassador-login" className="min-h-screen bg-[#0A0A0A] text-white font-manrope flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <img src="/breethe-logo.webp" alt="Breethe" className="h-8 w-auto" />
        <p className="mt-8 font-plex text-xs uppercase tracking-[0.3em] text-volt">Ambassador portal</p>
        <h1 className="mt-2 font-anton uppercase text-4xl leading-[0.9]">
          Welcome back<span className="text-volt">.</span>
        </h1>
        <form data-testid="ambassador-login-form" onSubmit={onLogin} className="mt-8 space-y-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="YOUR EMAIL"
            required
            data-testid="ambassador-email-input"
            className={inputCls}
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="PASSWORD"
            required
            data-testid="ambassador-password-input"
            className={inputCls}
          />
          {error && (
            <p data-testid="ambassador-login-error" className="font-plex text-xs uppercase tracking-[0.15em] text-volt">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="ambassador-login-submit-button"
            className="w-full h-14 bg-volt text-black font-anton uppercase tracking-wider text-base transition-[background-color,transform] duration-200 hover:bg-volt-dark active:scale-[0.98] disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Open my portal"}
          </button>
        </form>
        <a href="/" className="mt-6 inline-block font-plex text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-volt transition-colors">
          ← Back to breethe
        </a>
      </div>
    </div>
  );
};

export default AmbassadorLogin;
